/**
 * Settings service — OutpostForge frontend (CES standard)
 * Outpost registry management: which Outposts (account + region) the tool
 * manages. Registrations are validated server-side via GetOutpost.
 */

import type {
  ListRegistrationsResponse,
  OutpostRegistration,
  RegisterOutpostRequest,
} from '../../types/outposts';
import { http } from '../http';

export const settingsService = {
  async getRegistrations(): Promise<ListRegistrationsResponse> {
    const response = await http.get<ListRegistrationsResponse>('/settings/outposts');
    return response.data;
  },

  async registerOutpost(
    body: RegisterOutpostRequest,
  ): Promise<{ registration: OutpostRegistration }> {
    const response = await http.post<{ registration: OutpostRegistration }>(
      '/settings/outposts',
      body,
    );
    return response.data;
  },

  async removeOutpost(outpostId: string): Promise<void> {
    await http.delete(`/settings/outposts/${encodeURIComponent(outpostId)}`);
  },
};

export type SettingsService = typeof settingsService;
